var _path, _rect, _rect2, _rect3, _rect4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKtShootIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 39,
    viewBox: "0 0 38 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9999 4.52106C9.65427 5.94492 5.44486 10.1543 4.021 15.5H7.68277C8.88791 12.0904 11.5903 9.38797 14.9999 8.18283V4.52106ZM22.9999 8.18283V4.52106C28.3456 5.94492 32.555 10.1543 33.9789 15.5H30.3171C29.112 12.0904 26.4096 9.38797 22.9999 8.18283ZM22.9999 30.8172C26.4096 29.612 29.112 26.9097 30.3171 23.5H33.9789C32.555 28.8457 28.3456 33.0551 22.9999 34.479V30.8172ZM7.68277 23.5C8.88791 26.9097 11.5903 29.612 14.9999 30.8172V34.479C9.65427 33.0551 5.44486 28.8457 4.021 23.5H7.68277Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    width: 4,
    height: 10.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 27.5,
    width: 4,
    height: 11,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 17.5,
    width: 10.5,
    height: 4,
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 17.5,
    width: 10.5,
    height: 4,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKtShootIcon);
export default __webpack_public_path__ + "static/media/KtShootIcon.029260b328aae6d9b33518098a716d85.svg";
export { ForwardRef as ReactComponent };